<template>
  <section id="intro">
    <div v-html="intro.description"></div>
    <!-- <p class="one-pager"><a href="/static/AHCA_RepCampaign_Site_One-pager.pdf" onclick="trackOutboundLink('/static/AHCA_RepCampaign_Site_One-pager.pdf'); return false;">Our Quality Care One-Pager</a></p> -->
    <nav>
      <ul class="quick-links">
        <li v-for="(section, i) in sections" :key="i">
          <a :href="'#' + section.link" v-scroll-to="{
            el: '#' + section.link,
            offset: elOffset(section.link)
          }" :class="section.link">{{ section.name }} ></a>
        </li>
      </ul>
    </nav>
  </section>
</template>

<script>
/* eslint-disable */
export default {
  name: 'Intro',
  data () {
    return {
      intro: this.content.intro,
      sections: this.content.navigation
    }
  },
  methods: {
    elOffset: function(el) {
      if ($(window).width() > 576) {
        if (el == 'quality') {
          return -50;
        } else if (el == 'commitment') {
          return -50;
        } else {
          return -50;
        }
      } else {
        if (el == 'quality') {
          return -200;
        } else if (el == 'commitment') {
          return -300;
        } else {
          return -200;
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import '../_variables.scss';

#intro {
  @media (min-width: 768px) {
    padding: 0rem 0 4rem;
  }
  a {
    color: $black;
    &:hover {
      color: $white;
    }
  }
}
.one-pager {
  a {
    background: $black;
    color: $white;
    display: inline-block;
    padding: 5px 10px;
  }
}
.quick-links {
  list-style: none;
  margin: 70px 0 0;
  padding: 0;
  position: relative;
  z-index: 99;
  @media (min-width: 768px) {
    text-align: center;
  }
  li {
    list-style: none;
    margin: 0;
    padding: 0;
    @media (min-width: 768px) {
      display: inline-block;
      width: 33.333333%
    }
  }
  a {
    background: $white;
    padding: 2px 13px 8px 28px;
    margin-left: -30px;
    display: inline-block;
    color: $black;
    font-family: $antiqua;
    font-weight: 900;
    font-style: italic;
    font-size: 30px;
    transition: all .3s ease;
    @media (min-width: 768px) {
      width: auto;
      font-size: 22px;
      padding: 2px 10px 8px 10px;
    }
    &:hover,
    &:active {
      background: $black;
      color: $white;
      text-decoration: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Intro.vue